/*
 *  Project: dux - responsive tabs
 *  Description: make tabs responsive at the bottom of the page
 *  Author: bwin
 */

require( 'tab' );
require( 'vendor/jquery-watch' );

;(function ( $, window, document, undefined ){

    var pluginName = 'dv_tabs',
        _self,
        defaults = {};

    function Plugin( element, options ){

        _self = this;

        this.element = element;
        this.$element = $( element );

        this.options = $.extend( {}, defaults, options );

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
        this._watchAttributes( '_tabAttr' );
        this._watchChildren( '_tabChildren' );

    }

    $.extend( Plugin.prototype, {
        init: function (){

            $( window ).on( 'resize', function ( e ){

                e.preventDefault();

                var $win = $( this ),
                    $openList = $( '.dv-responsive-tabs.expanded' ),
                    $current = $( '.dv-responsive-tabs li.current' );

                if ( $win.width() > 399 ) {
                    $openList.removeClass( 'expanded' );
                    $current.remove();
                }

            } );

            this.$element.addClass( 'dv-responsive-tabs' );

            if ( !this.$element.children( '.caret' ).length ) {
                this.$element.append( '<span class="caret dv-rotate-180"></span>' );
                this.$element.append( '<span class="caret"></span>' );
            }

            this.$element.on( 'discard.active', 'li', function (){

                _self._switchToFirstVisibleTab( this );

                $(this).trigger( 'show.bs.tab' )

            } );

            this.$element.on( 'show.bs.tab', function (){

                var $this = $( this ),
                    $visible,
                    $hiddenActive;

                $this.addClass( 'expanded' ).removeClass( 'hidden' );
                $visible = $this.children( 'li:not(.current):visible' );
                $hiddenActive = $this.children( 'li.active:hidden' );

                $this.removeClass( 'expanded' );

                if ( $visible.length + $hiddenActive.length <= 1 ) {
                    $this.addClass( 'hidden' );
                }

            } );

            this.$element.on( 'shown.bs.tab', function (){

                var $this = $( this ),
                    $current = $this.children( 'li.current' );

                $this.removeClass( 'expanded' );

                $current.remove();

                _self._watchAttributes( '_tabAttr' );
                _self._watchChildren( '_tabChildren' );


            } );

            this.$element.on( 'click', 'li.active > a', function ( e ){

                e.preventDefault();

                _self.$element.toggleClass( 'expanded' );

                if ( _self.$element.hasClass( 'expanded' ) && $( window ).width() <= 399 ) {
                    _self._determineCurrent();
                } else {
                    _self.$element.trigger( 'shown.bs.tab' );
                }

            } );

            this.$element.on( 'click', 'li:not(.active):not(.current) > a', function ( e ){

                e.preventDefault();

                $( this ).tab( 'show' );

            } );

            this.$element.on( 'click', 'li.current > a, span.caret', function ( e ){

                e.preventDefault();

                _self.$element.toggleClass( 'expanded' );
                _self.$element.children( '.current' ).remove();

            } );

        },
        _determineCurrent: function (){

            var $activeTab = this.$element.children( 'li.active' );

            $activeTab
                .clone( true )
                .prependTo( this.$element )
                .removeAttr( 'class' )
                .addClass( 'current' );

        },
        _switchToFirstVisibleTab: function ( elm ){

            var $this = $( elm );

            this.$element.addClass( 'expanded' ).removeClass( 'hidden' );
            $this.siblings( 'li:visible' ).not( '.current' ).first().children( 'a' ).tab( 'show' );

        },
        _watchAttributes: function ( id ){

            this.$element.children( 'li' ).unwatch( id );

            this.$element.children( 'li' ).watch( {
                properties: 'attr_style,attr_class',
                id: id,
                watchChildren: false,
                callback: function ( data, i ){

                    var $this = $( this ),
                        propChanged = data.props[ i ],
                        valChanged = $.trim( data.vals[ i ] );


                    if ( propChanged === 'attr_style' && valChanged.match( 'display' ) ) {

                        //change active context
                        if ( $this.hasClass( 'active' ) && $this.is( ':hidden' ) ) {

                            $this.trigger( 'discard.active' );

                        } else {

                            // _self.$element.removeClass( 'hidden' );
                            $this.trigger( 'show.bs.tab' );

                        }
                    }

                    else if ( propChanged === 'attr_class' ) {

                        if ( $this.hasClass( 'active' ) && $this.is( ':hidden' ) ) {

                            $this.trigger( 'discard.active' );

                        } else {

                            // _self.$element.removeClass( 'hidden' );
                            $this.trigger( 'show.bs.tab' );

                        }
                    }
                }

            } );
        },
        _watchChildren: function ( id ){

            this.$element.unwatch( id );

            this.$element.watch( {
                properties: 'prop_innerHTML',
                id: id,
                watchChildren: true,
                callback: function ( data, i, mutations ){

                    var $this = $( this );

                    mutations.forEach( function ( record ){

                        if ( record.type === 'childList' && record.removedNodes.length > 0 ) {

                            var $remTab = $( record.removedNodes[ 0 ] );

                            // change active context if active tab has been removed
                            if ( $remTab.hasClass( 'active' ) && !$remTab.hasClass( 'current' ) ) {

                                $this.addClass( 'expanded' ).removeClass( 'hidden' );
                                $this.children( 'li:visible' ).first().children( 'a' ).tab( 'show' );
                            }

                            // watch non active tabs.
                            else if ( !$remTab.hasClass( 'current' ) ) {

                                $this.trigger( 'show.bs.tab' ).trigger( 'shown.bs.tab' );
                            }
                        }

                        else {

                            // watch for new added tabs
                            if (
                                record.type === 'childList' &&
                                record.addedNodes.length > 0 &&
                                $( record.addedNodes[ 0 ] ).is( 'li:not(.current)' ) === true
                            ) {

                                var $newTab = $( record.addedNodes[ 0 ] );

                                $newTab.trigger( 'show.bs.tab' ).trigger( 'shown.bs.tab' );
                            }
                        }
                    } );
                }
            } );
        },
        refresh: function (){

            this.$element.off().unbind();
            $( window ).off().unbind();

            this.init();
            $( window ).trigger( 'resize' );

            this._watchAttributes( '_tabAttr' );
            this._watchChildren( '_tabChildren' );
        }
    } );

    $.fn[ pluginName ] = function ( options ){
        var args = arguments;

        if ( options === undefined || typeof options === 'object' ) {

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );

        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            var returns;

            this.each( function (){

                var instance = $.data( this, 'plugin_' + pluginName );

                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }

            } );

            return returns !== undefined ? returns : this;
        }
    };

})( jQuery, window, document );

;(function ( $, window, document, undefined ){
    $( function (){

        $( '.nav-tabs-bottom' ).each( function (){

            var $this = $( this );

            $this.dv_tabs();

        } );
    } );
})( jQuery, window, document );